import FinishPage from '@portal/features/auth/email/FinishPage'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <FinishPage />
}

export const Route = createFileRoute('/signin/email/finish')({
  component: RouteComponent,
})
